import { useEffect } from 'react';
import moment from 'moment-timezone';

const DAY_TO_INDEX = {
    sunday: 0,
    monday: 1,
    tuesday: 2,
    wednesday: 3,
    thursday: 4,
    friday: 5,
    saturday: 6
};

export const DEFAULT_START_DAY = 'monday';

export default function useFirstDayOfTheWeek(startDay = DEFAULT_START_DAY, locale = 'en') {
    useEffect(() => {
        const weekStartIndex = DAY_TO_INDEX[startDay.toLowerCase()];
        const defaultDayIndex = DAY_TO_INDEX.monday;

        moment.locale(locale, {
            week: {
                dow: weekStartIndex ?? defaultDayIndex,
                doy: 1
            }
        });
    }, [startDay, locale]);
}